// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_SyncPaymentLinkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/links/sync_payment_link/{id}
 *
 * No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface SubaccountsLinks_SyncPaymentLinkInput {}

registerContract('SubaccountsLinks_SyncPaymentLinkInput', {})
